import { CheckboxList } from '@zola/zola-ui/src/components/Form/CheckboxList';
import { FormInput } from '@zola/zola-ui/src/components/Form/InputFieldV2';

import { FieldArray } from 'react-final-form-arrays';

import { REQUIRED } from '~/components/common/form/commonValidations';
import { FormCheckbox } from '~/components/common/form/FinalForm/Inputs';

import { GeneralQuestions } from './GeneralQuestions';

import styles from './questions.module.less';

const VENUE_ATMOSPHERE = [
  {
    value: 'venue-guest-emotion-relaxed-and-casual',
    label: 'Relaxed and Casual',
  },
  {
    value: 'venue-guest-emotion-luxurious-and-chic',
    label: 'Luxurious and Chic',
  },
  {
    value: 'venue-guest-emotion-warm-and-cozy',
    label: 'Warm and Cozy',
  },
  {
    value: 'venue-guest-emotion-fun-and-festive',
    label: 'Fun and Festive',
  },
];

export const VenueQuestions = (): JSX.Element => (
  <div className={styles.venue}>
    <GeneralQuestions />
    <div className={styles.general}>
      <FormInput name="guestCount" label="Guest Count" type="number" />
      <FormCheckbox
        className={styles.flexible}
        name="flexibleOnGuestCount"
        label="This is flexible"
      />
    </div>
    <fieldset>
      <legend>Venue Atmosphere</legend>
      <FieldArray
        options={VENUE_ATMOSPHERE}
        name="optionFacetKeys"
        id="venueAtmosphere"
        validate={REQUIRED}
      >
        {({ fields, meta }) => (
          <CheckboxList fields={fields} meta={meta} options={VENUE_ATMOSPHERE} />
        )}
      </FieldArray>
    </fieldset>
  </div>
);
